import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";

export default function Scanner({ onDetected, onClose }) {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let active = true;

    async function start() {
      try {
        setErr("");
        const reader = new BrowserMultiFormatReader();

        const video = videoRef.current;
        if (!video) return;

        const devices = await BrowserMultiFormatReader.listVideoInputDevices();
        const backCam =
          devices.find((d) => /back|rear|environment/i.test(d.label)) || devices[devices.length - 1];

        controlsRef.current = await reader.decodeFromVideoDevice(
          backCam?.deviceId,
          video,
          (result, error, controls) => {
            controlsRef.current = controls;
            if (!active) return;
            if (result) {
              const text = result.getText?.() || String(result);
              if (text) onDetected?.(text);
            }
          }
        );
      } catch (e) {
        setErr(String(e?.message || e));
      }
    }

    start();

    return () => {
      active = false;
      try {
        controlsRef.current?.stop?.();
      } catch {}
    };
  }, [onDetected]);

  function close() {
    try {
      controlsRef.current?.stop?.();
    } catch {}
    onClose?.();
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "rgba(0,0,0,0.75)",
        display: "grid",
        placeItems: "center",
        padding: 12,
      }}
    >
      <div style={{ width: "min(720px, 100%)", background: "white", borderRadius: 14, overflow: "hidden" }}>
        <div style={{ display: "flex", gap: 8, alignItems: "center", padding: 10 }}>
          <div style={{ fontWeight: 900 }}>スキャン</div>
          <button
            onClick={close}
            style={{ marginLeft: "auto", padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", background: "white", fontWeight: 900 }}
          >
            閉じる
          </button>
        </div>

        <div style={{ background: "#000" }}>
          <video ref={videoRef} style={{ width: "100%", height: "auto" }} />
        </div>

        {err ? (
          <div style={{ padding: 10, color: "#b91c1c", fontWeight: 800 }}>
            カメラ起動に失敗：{err}
            <div style={{ marginTop: 6, opacity: 0.8, fontWeight: 700 }}>
              ※ HTTPS / 権限許可 / 他アプリがカメラ使用中 など確認してください
            </div>
          </div>
        ) : (
          <div style={{ padding: 10, opacity: 0.75, fontWeight: 800 }}>バーコードをカメラに映してください</div>
        )}
      </div>
    </div>
  );
}
